const TEAM_PLAN_SLUGS = ['empresarial', 'enterprise', 'business'];

export function canAccessTeam(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true && user.role === 'admin') return true;
  if (user.role === 'employee') return false;

  const slug = String(user.currentPlan?.slug || '').toLowerCase();
  const features = {
    ...(user.currentPlan?.features || {}),
    ...(user.unlockedFeatures || {}),
  };
  return TEAM_PLAN_SLUGS.includes(slug) && features.employeeAccounts === true;
}

export function canManageTeam(user) {
  return canAccessTeam(user);
}
